import { render, staticRenderFns } from "./DriverLeaveStat.vue?vue&type=template&id=ec010118&scoped=true"
import script from "./DriverLeaveStat.vue?vue&type=script&lang=js"
export * from "./DriverLeaveStat.vue?vue&type=script&lang=js"
import style0 from "./DriverLeaveStat.vue?vue&type=style&index=0&id=ec010118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec010118",
  null
  
)

export default component.exports